import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getTeacherAccessGroupsType} from "./__graphql-types__/index.ts";

export const TEACHER_ACCESS_GROUPS_QUERY: GqlOperation<
    getTeacherAccessGroupsType["response"],
    getTeacherAccessGroupsType["variables"]
> = gqlOp(gql`
    query getTeacherAccessGroups {
        user {
            id
            hasAccessToAIGuideDistrictClassroomTeacher
        }
    }
`);
